import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http'
import { Injectable } from '@angular/core'
import { Observable } from 'rxjs'
import { switchMap } from 'rxjs/operators'
import { AuthService } from './auth.service'

@Injectable()
export class SecurityInterceptor implements HttpInterceptor {

  constructor (
    private auth: AuthService,
  ) { }

  intercept (req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return this.auth.isAuthenticated().pipe(switchMap(isAuthenticated =>{
      if(isAuthenticated) {
        return this.auth.getAccessToken().pipe(
          switchMap(token => next.handle(req.clone({ setHeaders: { Authorization: `Bearer ${token}` } })))
        )
      } else {
        return next.handle(req)
      }
    }))
  }
}
